define('view/controller/booking/provider/ProviderItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var ThemeSettings = require('lib/theme/ThemeSettings');
	
	/**
	 * Provider info view (provider item)
	 * 
	 * @class ProviderItemView
	 */
	return LayoutView.extend({

		getTemplate: function () {
			if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
				return '#provider_item_list';
			}
			return '#provider_item';
		}
	    
	});
	
});
